
export default () => ({
    events: [],
    event: {},
    action: 'S'
})